// extracted by mini-css-extract-plugin
export var container = "landing-module--container--1e102";
export var headerBlurSvg = "landing-module--headerBlurSvg--97a69";
export var mainContent = "landing-module--mainContent--e55b5";